import React from 'react';
import PropTypes from 'prop-types';

import {
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
} from 'common/applicationAssemblyLineConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrApplicationAssemblyLineContainerBox from 'client/components/SrApplicationAssemblyLine/SrApplicationAssemblyLineContainerBox';

const SrApplicationAssemblyLineContainerBoxComparisons = ({
  status,
  comparisons,
}) => {
  return (
    <SrApplicationAssemblyLineContainerBox status={status}>
      <SrFlex>
        <SrBox>
          <SrText font='greycliff' color='grey600' size='14' weight='700'>
            {comparisons[0]?.title}
          </SrText>
          <br />
          <SrText
            font='greycliff'
            size='16'
            weight='700'
            color={status === SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED
              ? 'green'
              : 'blueGreycliff'
            }
          >
            {comparisons[0]?.value}
          </SrText>
        </SrBox>
        <SrBox margin='0 24px 0 54px'>
          <SrBox height='100%' width='1px' backgroundColor='#CED3DA' />
        </SrBox>
        <SrBox>
          <SrText font='greycliff' color='grey600' size='14' weight='700'>
            {comparisons[1]?.title}
          </SrText>
          <br />
          <SrText font='greycliff' size='16' weight='700'>
            {comparisons[1]?.value}
          </SrText>
        </SrBox>
      </SrFlex>
    </SrApplicationAssemblyLineContainerBox>
  );
};

SrApplicationAssemblyLineContainerBoxComparisons.propTypes = {
  status: PropTypes.string.isRequired,
  comparisons: PropTypes.array.isRequired,
};

SrApplicationAssemblyLineContainerBoxComparisons.displayName = 'SrApplicationAssemblyLineContainerBoxComparisons'; // eslint-disable-line max-len

export default SrApplicationAssemblyLineContainerBoxComparisons;
